import { erstelleNutzerEinstellung } from "./nutzerEinstellung";
import { GLOCKE_POSTFAECHER_SCOPE, normalisiereGlockenWahl, type GlockenWahl } from "./glockenPostfaecher";
import { normalisiereStandardAbsender, STANDARD_ABSENDER_SCOPE } from "./startAbsender";

/** T-249: Welche Postfächer zählen in Glocke, „Schriftverkehr"-Badge und Dashboard? */
export const glockenEinstellung = erstelleNutzerEinstellung<GlockenWahl>({
    scope: GLOCKE_POSTFAECHER_SCOPE,
    standard: null,
    normalisiere: normalisiereGlockenWahl,
});

/** T-289: Mit welchem Postfach startet das Absenderfeld? `null` = wie bisher. */
export const standardAbsenderEinstellung = erstelleNutzerEinstellung<string | null>({
    scope: STANDARD_ABSENDER_SCOPE,
    standard: null,
    normalisiere: normalisiereStandardAbsender,
});

/** `aktiv = false` (nicht angemeldet): nichts laden, Stand vergessen. */
export const useGlockenPostfaecher = (aktiv = true) => glockenEinstellung.useEinstellung(aktiv);
export const useStandardAbsender = () => standardAbsenderEinstellung.useEinstellung();
